import type { ReactNode } from 'react';

import replaceStringWithElement from '../replaceStringWithElement';

const newLineRegExp = /\n/;

const convertNewLineToBreakTag = (text: string | ReactNode[]): readonly ReactNode[] =>
    replaceStringWithElement(text, newLineRegExp, <br />);

export default convertNewLineToBreakTag;
